(function () {
  document.documentElement.classList.add('inletix-hero-gsap-enabled');

  function showHeroItems(items) {
    items.forEach(function (item) {
      item.style.opacity = '1';
      item.style.transform = 'translateY(0)';
      item.style.visibility = 'visible';
    });
  }

  function animateHero() {
    var hero = document.querySelector('.inletix-hero');
    if (!hero) return;

    var items = Array.from(
      hero.querySelectorAll('.inletix-hero-title, .inletix-hero-text, .inletix-hero-btn')
    );

    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.gsap) {
      showHeroItems(items);
      return;
    }

    window.gsap.killTweensOf(items);
    window.gsap.set(items, {
      autoAlpha: 0,
      y: 72,
    });
    window.gsap.to(items, {
      autoAlpha: 1,
      y: 0,
      duration: 1.15,
      stagger: 0.16,
      ease: 'power3.out',
      delay: 0.15,
    });
  }

  function loadGsap(callback) {
    if (window.gsap) {
      callback();
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    script.onload = callback;
    script.onerror = function () {
      var hero = document.querySelector('.inletix-hero');
      if (!hero) return;

      showHeroItems(
        Array.from(hero.querySelectorAll('.inletix-hero-title, .inletix-hero-text, .inletix-hero-btn'))
      );
    };
    document.head.appendChild(script);
  }

  function init() {
    var hero = document.querySelector('.inletix-hero');
    if (!hero) return;

    var items = Array.from(
      hero.querySelectorAll('.inletix-hero-title, .inletix-hero-text, .inletix-hero-btn')
    );
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showHeroItems(items);
      return;
    }

    // Safety timeout: ensure hero is always visible even if CDN fails
    var safetyTimer = setTimeout(function () {
      showHeroItems(items);
    }, 1200);

    loadGsap(function () {
      clearTimeout(safetyTimer);
      animateHero();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      init();
    }
  });
})();
